export default {
    loaded: ({modules}) => modules.loaded,

    module_modals: ({modules}) => modules.module_modals,
    module_modals_data: ({modules}) => modules.module_modals_data,

    modals: ({modules}) => modules.modals,
    modals_data: ({modules}) => modules.modals_data
}